/**
 * FAQ Directory — marks the category the reader has scrolled to.
 *
 * The same rule the article contents rail follows, so both rails change at the
 * same place on screen: the category lights once its section has passed under
 * the header, not while it is still halfway down the viewport.
 *
 * The accordions themselves are handled by the shared Disclosure component,
 * which already binds every [data-accordion] group on the page.
 */

import { scrollSpy } from '../../global/js/components/scroll-spy';

document.querySelectorAll( '[data-faq-directory]' ).forEach( ( root ) => {
	scrollSpy( Array.from( root.querySelectorAll( '[data-faq-jump]' ) ) );
} );
